import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService, notCloseMessageOptions } from '../../../../core';
import { DatepickerComponent } from '../../../../shared';
import { SimplesNacional } from '../simples-nacional';

@Component({
    selector: 'sgt-simples-nacional-form',
    templateUrl: './simples-nacional-form.component.html',
    styleUrls: ['./simples-nacional-form.component.less']
})
export class SimplesNacionalFormComponent {
    @Input() entity: SimplesNacional;
    @Input() canEdit = true;
    /** Se o form deve ser exibido em tamanho pequeno */
    @Input() isMini = false;

    @ViewChild('form') form: NgForm;
    @ViewChild('optanteSimplesNacionalDataDatepicker') optanteSimplesNacionalDataDatepicker: DatepickerComponent;

    constructor(private messageService: MessageService) { }

    /** Verifica se o form e suas informações está válidas */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        // Optante pelo Simples Nacional e não informada data de opção
        if (this.entity.optanteSimplesNacional && !this.entity.optanteSimplesNacionalData) {
            this.messageService.warning('Selecionado empresa Optante pelo Simples Nacional e não informada a data de opção. Informe a data de opção e tente novamente', 'Atenção', notCloseMessageOptions);
            setTimeout(() => this.optanteSimplesNacionalDataDatepicker?.setFocus(), 100);
            return false;
        }

        // Form válido
        if (!this.form.valid) {
            this.messageService.warning('Informe corretamente todos os campos do Simples Nacional da empresa', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
